//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class NumberFormatInfo extends ItemBase {
    DecimalSeparator: string | null = null;
    GroupSeparator: string | null = null;
    GroupSizes: number[] = [];
    NegativePattern: string | null = null;
    PositivePattern: string | null = null;

    constructor(initializer?: Partial<NumberFormatInfo>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "NumberFormatInfo";
}
